// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"3619":"ShipmentAllocationsPage","4248":"ReceivablesInvoicesPage"}[chunkId] + "." + {"3619":"6bb0cefd","4248":"8e6557af"}[chunkId] + ".chunk.css";
};